export enum ProductStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
